$ = require 'jquery'
Auth = require 'db/auth'
AutoInsertionView = require 'views/internal/autocomplete/auto-insertion-view'
AutoMentionerView = require 'views/internal/autocomplete/auto-mentioner-view'
CheckItemListView = require 'views/checklist/check-item-list-view'
CompleterUtil = require 'views/internal/autocomplete/completer-util'
Confirm = require 'views/lib/confirm'
DragSort = require 'views/lib/drag-sort'
EditableView = require 'views/internal/editable-view'
EmojiCompleterView = require 'views/internal/autocomplete/emoji-completer-view'
Keyboard = require 'lib/keyboard'
Layout = require 'views/lib/layout'
MemberState = require 'view-models/member-state'
PopOver = require 'views/lib/pop-over'
Promise = require 'bluebird'
Util = require 'lib/util'
_ = require 'underscore'
log = require 'debug/log'
mixin = require 'lib/mixin'
templates = require 'views/internal/templates'
track = require 'debug/track'
l = require 'lib/localize'
ninvoke = require 'lib/util/ninvoke'

module.exports = mixin AutoInsertionView, CompleterUtil, class ChecklistView extends EditableView
  className: 'checklist'

  initialize: ->
    @makeDebouncedMethods 'renderCheckedState'

    @listenTo @model.checkItemList,
      'add remove reset change:state': ->
        @renderProgress()
        @renderCheckedStateDebounced()

    @listenTo MemberState,
      'change:idCollapsedChecklists': @renderCheckedStateDebounced

    @listenTo @model,
      'change:name': @renderName
      'change:limits': @renderInput

  events:
    # new checklist item stuff
    'keydown .js-new-checklist-item-input': 'keydownChecklistEvent'
    'click .js-add-checklist-item': 'submitTask'
    'click .js-cancel-checklist-item': 'cancelItemEditing'
    'click .js-new-checklist-item-input': 'focusNewTaskInput'
    'click :not(.focus) .js-new-checklist-item-input': (e) ->
      $(e.currentTarget).select()

    # options
    'click .js-confirm-delete': 'confirmDeleteChecklist'

    'click .js-hide-checked-items': 'hideCheckedItems'
    'click .js-show-checked-items': 'showCheckedItems'

    # reorder checklist and checklist items
    'sortstop .js-checklist-items-list': 'sortStop'
    'sortreceive .js-checklist-items-list': 'sortReceive'
    'movechecklist': 'moveChecklist'

    # autocomplete stuff
    'keyup .js-new-checklist-item-input': 'keyAutoMention'
    'click .js-open-mention-selector': 'commentMentionMember'
    'click .js-open-emoji-selector': 'commentAddEmoji'

  render: ->
    log('render', "rendering checklist state " + @model.get('name'))

    @$el.html(templates.fillFromModel('checklist', @model))
    $checkItemList = @$('.js-checklist-items-list')

    if @getCard()?.editable()
      $checkItemList.sortable
        axis: 'y'
        delay: '75'
        distance: '7'
        tolerance: 'pointer'
        placeholder: 'checklist-item placeholder'
        items: '.checklist-item'
        connectWith: '.js-checklist-items-list'
        start: (event, ui) ->
          DragSort.sorting = true
          _height = $(ui.helper).outerHeight()
          $(ui.placeholder).height(_height)
        stop: =>
          # Must defer this for the glory of Firefox!
          @defer ->
            DragSort.sorting = false

    @$newCheckItemInput = @$('.js-new-checklist-item-input').autosize()

    @renderName()
    @renderCheckItems()
    @renderInput()

    @renderCheckedState()

    @

  renderInput: ->
    overLimit = @model.isOverLimit('checkItems', 'perChecklist')
    @$('.js-new-checklist-item').toggleClass('hide', overLimit)
    @$('.js-new-checklist-item-limit-exceeded').toggleClass('hide', !overLimit)

    @

  renderName: ->
    @$('div.checklist-title[attr=name] .current').text(@model.get('name'))
    @

  renderProgress: ->
    countComplete = @model.getCompletedCount(@getCard())
    countTotal = @model.checkItemList.length
    percentComplete = if countTotal > 0 then Math.round(100.0 * countComplete / countTotal) else 0
    complete = countComplete == countTotal && countTotal > 0

    @$('.js-checklist-progress-bar').width(percentComplete + "%")
    @$('.js-checklist-progress-percent').text(percentComplete + "%")

    @$('.js-checklist-progress-bar').toggleClass('checklist-progress-bar-current-complete', complete)

    @

  renderCheckItems: ->
    $checkItemList = @$('.js-checklist-items-list')

    checkItemListView = @collectionSubview CheckItemListView,
      @model.checkItemList, { el: $checkItemList }
    checkItemListView.render()

    DragSort.refreshIfInitialized($checkItemList)
    @renderProgress()
    @

  isChecklistCollapsed: ->
    MemberState.inSet('idCollapsedChecklists', @model.id)

  renderCheckedState: (e) ->
    countItems = @model.checkItemList.length
    countComplete = @model.getCompletedCount(@getCard())
    hasCheckItems = countItems > 0
    complete = countItems == countComplete && countItems > 0

    @$('.js-show-checked-items')
    .text l('show checked items', { count: countComplete.toString() })

    @$('.js-completed-message').addClass('hide')

    if countComplete == 0 || !hasCheckItems
      @$el.removeClass('hide-completed-items')
      @$('.js-show-checked-items').addClass('hide')
      @$('.js-hide-checked-items').addClass('hide')
    else if @isChecklistCollapsed()
      @$el.addClass('hide-completed-items')
      @$('.js-show-checked-items').removeClass('hide')
      @$('.js-hide-checked-items').addClass('hide')
      @$('.js-completed-message').toggleClass('hide', !complete)
    else
      @$el.removeClass('hide-completed-items')
      @$('.js-show-checked-items').addClass('hide')
      @$('.js-hide-checked-items').removeClass('hide')

    @

  hideCheckedItems: (e) ->
    Util.stop(e)
    MemberState.pushCollapsedChecklist(@model.id)
    track("Checklist", "Hide Checked Items")
    return

  showCheckedItems: (e) ->
    Util.stop(e)
    MemberState.pullCollapsedChecklist(@model.id)
    track("Checklist", "Show Checked Items")
    return

  getCard: -> @options.card
  # For CompleterUtil
  selfMention: true

  cancelItemEditing: (e) ->
    $(e.target).closest('.js-new-checklist-item').find('.js-new-checklist-item-input').val('')
    Layout.cancelEdits()
    false

  focusNewTaskInput: (e) ->
    Layout.cancelEdits(@$newCheckItemInput)
    @$newCheckItemInput.focus()
    @$('.js-new-checklist-item').addClass('focus')
    return

  keydownChecklistEvent: (e) ->
    if $(e.target).hasClass('js-new-checklist-item-input')
      if (PopOver.view instanceof EmojiCompleterView) || (PopOver.view instanceof AutoMentionerView)
        @checkInsert(e)

      else if Keyboard.isSubmitEvent(e)
        @submitTask(e)

  getTextInput: ->
    @$('.js-new-checklist-item-input')

  getMentionTarget: ->
    @$('.js-open-mention-selector')[0]

  getEmojiTarget: ->
    @$('.js-open-emoji-selector')[0]

  submitTask: (e) ->
    Util.stop(e)
    s = @$newCheckItemInput.val().trim()

    if /^\s*$/.test(s)
      Util.stop(e)
      @focusNewTaskInput()
      return false

    taskNames = _.compact(s.split(/\r\n|\r|\n/))
    checklist = @model

    # [LOCK]
    Promise.using checklist.modelCache.getLock(), =>
      Promise.resolve(taskNames)
      .each (name) =>
        if checklist.checkItemList.length > 0
          pos = checklist.checkItemList.last().get('pos') + Util.spacing
        else
          pos = Util.spacing

        # Also add a little bit of randomness to make it unlikely that another
        # client would send a checkitem with the exact same pos
        pos += Math.floor(Math.random() * 1024)

        return Promise.fromNode (next) ->
          checkItem = checklist.checkItemList.create
            name: name.trim()
            pos: pos
            nameData:
              emoji: Auth.me().allCustomEmoji()
          ,
            error: =>
              checklist.checkItemList.remove(checkItem)
          , next
    .done()

    @$newCheckItemInput.val("").trigger('autosize.resize')
    @focusNewTaskInput()

    multi = if taskNames.length == 1 then "Single Item" else "Multiple Items"
    track("Checklist", "Add Checklist Item", multi)

    PopOver.hide()

    return

  sortStop: (e, ui) ->
    Util.stopPropagation(e)
    ui.item.trigger('movecheckitem', [ui, @model, false])
    return

  sortReceive: (e, ui) ->
    Util.stopPropagation(e)
    ui.item.trigger('movecheckitem', [ui, @model, true])
    return

  confirmDeleteChecklist: (e) ->
    Util.stop(e)

    checklistName = @model.get('name')

    Confirm.toggle 'delete checklist',
      elem: @$(e.target).closest('.js-confirm-delete')
      model: @model
      title: l('confirm.delete checklist.title', { checklistName })
      confirmBtnClass: 'negate'
      fxConfirm: (e) =>
        track("Checklist", "Delete Checklist")
        @model.destroy()

    return

  moveChecklist: (e, ui) ->
    card = @model.getCard()
    if card?
      checkItems = ui.item.parent().children()
      index = checkItems.index(ui.item)
      @model.update('pos', card.calcChecklistPos(index, @model))
      @model.collection.sort({ silent: true })

      track("Checklist", "Reorder Checklist")

    return

# [LOCK]
#
# This looks unnecessary, since `create` is going to lock the modelCache as
# well. However, there is a brief period of time in between creations where it
# will unlock, then map a potentially old delta (that contains the entire list
# of checkitems, of course, because that's how checkitem deltas work), then the
# next time around the function that calculates the new pos will have stale
# data, as by mapping an older delta we've effectively "uncreated" the previous
# check item in the list. The net effect is that, without this outer lock,
# check items can show up in the wrong order.



// WEBPACK FOOTER //
// ./app/scripts/views/checklist/checklist-view.coffee